import React, { useState } from "react";
import { useParams } from "react-router-dom";
import * as microsoftTeams from "@microsoft/teams-js";
import { Flex, Button, Checkbox, TextArea } from "@fluentui/react-northstar";
import { AxiosError } from "axios";
import { useApp } from "../../contexts/appContext";
import styles from "./commonModal.module.scss";
import { hasValue } from "../../common/textOperations";
import { useAuth } from "../../contexts/authContext";
import { addComment } from "../../services/dataService";
import IComment from "../../interfaces/IComment";

const CreateInternalComment = () => {
  const params = new URLSearchParams(window.location.search);
  const queryData: IComment = JSON.parse(params.get("data") ?? "");
  const { id } = useParams<{ id: string }>();
  const [subject, setSubject] = useState("");
  const [engaged, setEngaged] = useState(queryData.engaged);
  const [firstResponse, setFirstResponse] = useState(queryData.firstResponse);
  const [followUp, setFollowUp] = useState(queryData.followUp);
  const { state: appState, dispatch } = useApp();
  const { state: authState } = useAuth();
  const { accessToken: token } = authState;
  const { isDarkTheme } = appState;
  const { supportProject } = queryData;
  
  const toggleLoading = (loading: boolean) => {
    dispatch({ type: "SET_LOADER", show: loading });
  };

  const createComment = async () => {
    if (!token || !id) { return; }
    toggleLoading(true);
    try {
      const data: IComment = {
        supportProject,
        engaged,
        firstResponse,
        followUp,
        subject
      };

      await addComment(token, id, data);
      toggleLoading(false);
    } catch (error) {
      const err: AxiosError = error as AxiosError;
      toggleLoading(false);
      if (err.response?.status === 401) {
      } else {
        console.log(err.response?.data);
      }

      throw error;
    }
  }

  const confirmDialog = async () => {
    await createComment();
    microsoftTeams.dialog.url.submit();
  }

  const formIsValid = () => { return hasValue(subject); };

  return (
    <Flex gap="gap.medium" column className={styles.container} style={{ backgroundColor: isDarkTheme ? "#292929" : "#FFFFFF" }}>
      <Flex column gap="gap.small">
        <TextArea
          placeholder="Interní komentář"
          value={subject}
          rows={6} maxLength={400}
          onChange={(_: any, data: any) => setSubject(data.value)}
        />
        {supportProject &&
          <>
            <Checkbox
              label="Engaged"
              defaultChecked={engaged}
              disabled={queryData.engaged}
              onChange={(_: any, data: any) => setEngaged(data.checked)}
            />
            <Checkbox
              label="First Response"
              defaultChecked={firstResponse}
              disabled={queryData.firstResponse}
              onChange={(_: any, data: any) => setFirstResponse(data.checked)}
            />
            <Checkbox
              label="Follow Up"
              defaultChecked={followUp}
              disabled={queryData.followUp}
              onChange={(_: any, data: any) => setFollowUp(data.checked)}
            />
          </>
        }
      </Flex>

      <Flex>
        <Flex fill></Flex>
        <Flex gap="gap.medium">
          <Button content="Zrušit" onClick={() => microsoftTeams.dialog.url.submit()} disabled={appState.showLoader} />
          <Button content="Uložit" primary onClick={confirmDialog} loading={appState.showLoader} disabled={!formIsValid() || appState.showLoader} />
        </Flex>
      </Flex>

    </Flex>
  );
};

export default CreateInternalComment;
